import { TypePolicy } from '@apollo/client'

export const PharmacyTypePolicy: TypePolicy = {
  keyFields: ['nabp'],
}
